import { toUpper } from "lodash";

export const SYSTEM_TYPES = {
    OVERVIEW: 'overview',
    ESERIES: 'eseries',
    ONTAP: 'ontap',
    STORAGEGRID: 'storageGrid'
};

export const ONTAP_STORAGE_OBJECTS = {
    SYSTEMS: 'systems',
    SVMS: 'svms',
    VOLUMES: 'volumes',
    LUNS: 'luns',
    NODES: 'nodes',
    LOCAL_TIERS: 'localTiers',
    SMBSHARES: 'smbShares',
    NAMESPACE: 'namespaces',
    QTREES: 'qtrees',
    INTERFACES: 'interfaces',
    PORTS: 'ports'
};

export const OVERVIEW_STORAGE_OBJECTS = {
    SYSTEMS: 'systems',
    SVMS: 'svms',
    VOLUMES: 'volumes',
    LUNS: 'luns',
    NODES: 'nodes'
};

export const ESERIES_STORAGE_OBJECTS = {
    SYSTEMS: 'systems',
    LUNS: 'luns'
};

export const STORAGE_GRID_STORAGE_OBJECTS = {
    SYSTEMS: 'systems',
    NODES: 'nodes',
    TENANTS: 'tenants'
};

export const STORAGE_OBJECTS_BY_SYSTEM_TYPE = {
    [SYSTEM_TYPES.OVERVIEW]: OVERVIEW_STORAGE_OBJECTS,
    [SYSTEM_TYPES.ESERIES]: ESERIES_STORAGE_OBJECTS,
    [SYSTEM_TYPES.ONTAP]: ONTAP_STORAGE_OBJECTS,
    [SYSTEM_TYPES.STORAGEGRID]: STORAGE_GRID_STORAGE_OBJECTS
};

export const ONTAP_API_STORAGE_OBJECTS = {
    [ONTAP_STORAGE_OBJECTS.SYSTEMS]: 'clusters',
    [ONTAP_STORAGE_OBJECTS.SVMS]: 'svms',
    [ONTAP_STORAGE_OBJECTS.VOLUMES]: 'volumes',
    [ONTAP_STORAGE_OBJECTS.LOCAL_TIERS]: 'aggregates',
    [ONTAP_STORAGE_OBJECTS.LUNS]: 'luns',
    [ONTAP_STORAGE_OBJECTS.NODES]: 'nodes',
    [ONTAP_STORAGE_OBJECTS.QTREES]: 'qtrees',
    [ONTAP_STORAGE_OBJECTS.SMBSHARES]: 'smbshares',
    [ONTAP_STORAGE_OBJECTS.NAMESPACE]: 'namespaces',
    [ONTAP_STORAGE_OBJECTS.INTERFACES]: 'networkinterfaces',
    [ONTAP_STORAGE_OBJECTS.PORTS]: 'ports'
};

export const OVERVIEW_API_STORAGE_OBJECTS = {
    [OVERVIEW_STORAGE_OBJECTS.SYSTEMS]: 'systems',
    [OVERVIEW_STORAGE_OBJECTS.SVMS]: 'svms',
    [OVERVIEW_STORAGE_OBJECTS.VOLUMES]: 'volumes',
    [OVERVIEW_STORAGE_OBJECTS.LUNS]: 'systemluns',
    [OVERVIEW_STORAGE_OBJECTS.NODES]: 'systemnodes'
};

export const ESERIES_API_STORAGE_OBJECTS = {
    [ESERIES_STORAGE_OBJECTS.SYSTEMS]: 'eseriesarrays',
    [ESERIES_STORAGE_OBJECTS.LUNS]: 'eseriesvolumes'
};

export const STORAGE_GRID_API_STORAGE_OBJECTS = {
    [STORAGE_GRID_STORAGE_OBJECTS.SYSTEMS]: 'grids',
    [STORAGE_GRID_STORAGE_OBJECTS.NODES]: 'gridnodes',
    [STORAGE_GRID_STORAGE_OBJECTS.TENANTS]: 'gridtenants'
};

export const API_STORAGE_OBJECTS_BY_SYSTEM_TYPE = {
    [SYSTEM_TYPES.OVERVIEW]: OVERVIEW_API_STORAGE_OBJECTS,
    [SYSTEM_TYPES.ESERIES]: ESERIES_API_STORAGE_OBJECTS,
    [SYSTEM_TYPES.ONTAP]: ONTAP_API_STORAGE_OBJECTS,
    [SYSTEM_TYPES.STORAGEGRID]: STORAGE_GRID_API_STORAGE_OBJECTS
};

export const ONTAP_ACCEPT_HEADERS = {
    [ONTAP_STORAGE_OBJECTS.SYSTEMS]: 'application/vnd.netapp.bxp.clusters+json',
    [ONTAP_STORAGE_OBJECTS.VOLUMES]: 'application/vnd.netapp.bxp.volumes+json',
    [ONTAP_STORAGE_OBJECTS.SVMS]: 'application/vnd.netapp.bxp.svms+json',
    [ONTAP_STORAGE_OBJECTS.LOCAL_TIERS]: 'application/vnd.netapp.bxp.aggregates+json',
    [ONTAP_STORAGE_OBJECTS.LUNS]: 'application/vnd.netapp.bxp.luns+json',
    [ONTAP_STORAGE_OBJECTS.NODES]: 'application/vnd.netapp.bxp.nodes+json',
    [ONTAP_STORAGE_OBJECTS.QTREES]: 'application/vnd.netapp.bxp.qtrees+json',
    [ONTAP_STORAGE_OBJECTS.SMBSHARES]: 'application/vnd.netapp.bxp.smbshares+json',
    [ONTAP_STORAGE_OBJECTS.NAMESPACE]: 'application/vnd.netapp.bxp.namespaces+json',
    [ONTAP_STORAGE_OBJECTS.INTERFACES]: 'application/vnd.netapp.bxp.networkinterfaces+json',
    [ONTAP_STORAGE_OBJECTS.PORTS]: 'application/vnd.netapp.bxp.ports+json',
    FLEET: 'application/vnd.netapp.bxp.fleet+json'
};

export const OVERVIEW_ACCEPT_HEADERS = {
    [OVERVIEW_STORAGE_OBJECTS.SYSTEMS]: 'application/vnd.netapp.bxp.systems+json',
    [OVERVIEW_STORAGE_OBJECTS.SVMS]: 'application/vnd.netapp.bxp.svms+json',
    [OVERVIEW_STORAGE_OBJECTS.VOLUMES]: 'application/vnd.netapp.bxp.volumes+json',
    [OVERVIEW_STORAGE_OBJECTS.LUNS]: 'application/vnd.netapp.bxp.systemluns+json',
    [OVERVIEW_STORAGE_OBJECTS.NODES]: 'application/vnd.netapp.bxp.systemnodes+json'
};

export const ESERIES_ACCEPT_HEADERS = {
    [ESERIES_STORAGE_OBJECTS.SYSTEMS]: 'application/vnd.netapp.bxp.eseriesarrays+json',
    [ESERIES_STORAGE_OBJECTS.LUNS]: 'application/vnd.netapp.bxp.eseriesvolumes+json'
};

export const STORAGE_GRID_ACCEPT_HEADERS = {
    [STORAGE_GRID_STORAGE_OBJECTS.SYSTEMS]: 'application/vnd.netapp.bxp.grids+json',
    [STORAGE_GRID_STORAGE_OBJECTS.NODES]: 'application/vnd.netapp.bxp.gridnodes+json',
    [STORAGE_GRID_STORAGE_OBJECTS.TENANTS]: 'application/vnd.netapp.bxp.gridtenant+json'
};

export const ACCEPT_HEADERS_BY_SYSTEM_TYPE = {
    [SYSTEM_TYPES.OVERVIEW]: OVERVIEW_ACCEPT_HEADERS,
    [SYSTEM_TYPES.ESERIES]: ESERIES_ACCEPT_HEADERS,
    [SYSTEM_TYPES.ONTAP]: ONTAP_ACCEPT_HEADERS,
    [SYSTEM_TYPES.STORAGEGRID]: STORAGE_GRID_ACCEPT_HEADERS
};

export const VIEW_TYPES = {
    ALL: 'all',
    CAPACITY: 'capacity',
    PROTECTION: 'protection',
    HEALTH: 'health',
    PERFORMANCE: 'performance',
    SECURITY: 'security'
};

export const STATUS_LABEL_KEYS = {
    REACHABLE: 'reachable',
    UNREACHABLE: 'unreachable',
    UNKNOWN: 'unknown'
};

export const CLUSTER_STATE_LABEL_KEYS = {
    ONLINE: 'online',
    DEGRADED: 'degraded',
    OFFLINE: 'offline',
    UNKNOWN: 'unknown'
};

export const NODE_STATE_LABEL_KEYS = {
    UP: 'up',
    BOOTING: 'booting',
    DOWN: 'down',
    TAKEN_OVER: 'taken_over',
    WAITING_FOR_GIVEBACK: 'waiting_for_giveback',
    DEGRADED: 'degraded',
    UNKNOWN: 'unknown'
};

export const HA_STATE_LABEL_KEYS = {
    NOT_APPLICABLE: 'not_applicable',
    NORMAL: 'normal',
    WARNING: 'warning',
    ERROR: 'error'
};

export const VOLUME_STATE_LABEL_KEYS = {
    ERROR: 'error',
    MIXED: 'mixed',
    OFFLINE: 'offline',
    ONLINE: 'online',
    RESTRICTED: 'restricted'
};

export const LUN_STATE_LABEL_KEYS = {
    ONLINE: 'online',
    OFFLINE: 'offline',
    FOREIGN_LUN_ERROR: 'foreign_lun_error',
    NVFAIL: 'nvfail',
    SPACE_ERROR: 'space_error'
};

export const LUN_MAPPING_STATE_LABEL_KEYS = {
    MAPPED: 'mapped',
    UNMAPPED: 'unmapped'
};

export const AGGREGATE_STATE_LABEL_KEYS = {
    ONLINE: 'online',
    ONLINING: 'onlining',
    OFFLINE: 'offline',
    OFFLINING: 'offlining',
    RELOCATING: 'relocating',
    UNMOUNTED: 'unmounted',
    RESTRICTED: 'restricted',
    INCONSISTENT: 'inconsistent',
    FAILED: 'failed',
    UNKNOWN: 'unknown'
};

export const RAID_STATUS_LABEL_KEYS = {
    NORMAL: 'normal',
    DEGRADED: 'degraded',
    RESYNCING: 'resyncing',
    RECONSTRUCT: 'reconstruct',
    CHECKING: 'checking',
    UNKNOWN: 'unknown'
};

export const SHARE_STATE_LABEL_KEYS = {
    ONLINE: 'online',
    OFFLINE: 'offline'
};

export const INTERFACE_STATE_LABEL_KEYS = {
    UP: 'up',
    DOWN: 'down'
};

export const PORT_STATUS_LABEL_KEYS = {
    UP: 'up',
    DOWN: 'down'
};

export const SVM_SUBTYPE_LABEL_KEYS = {
    DEFAULT: 'default',
    DP_DESTINATION: 'dp_destination',
    SYNC_SOURCE: 'sync_source',
    SYNC_DESTINATION: 'sync_destination',
    DATA_ENGINE: 'data_engine'
};

export const SVM_OPERATIONAL_STATE_LABEL_KEYS = {
    RUNNING: 'running',
    STOPPED: 'stopped'
};

export const SVM_ADMIN_STATE_LABEL_KEYS = {
    STARTING: 'starting',
    RUNNING: 'running',
    STOPPING: 'stopping',
    STOPPED: 'stopped',
    DELETING: 'deleting',
    INITIALIZING: 'initializing'
};

export const FIPS_LABEL_KEYS = {
    YES: 'yes',
    NO: 'no',
    PARTIAL: 'partial'
};

export const SNAPMIRROR_STATE_LABEL_KEYS = {
    HEALTHY: 'healthy',
    LAGGING: 'lagging',
    BROKEN: 'broken'
};

export const SNAPMIRROR_TYPE_LABEL_KEYS = {
    ASYNC_MIRROR: 'async_mirror',
    ASYNC_VAULT: 'async_vault',
    MIRROR_VAULT: 'mirror_vault',
    SYNC: 'sync',
    STRICT_SYNC: 'strict_sync',
    SVM_DR: 'svm_dr',
    NONE: 'none'
};

export const statusFilterOptions = (t) => Object.keys(STATUS_LABEL_KEYS).map(value => ({
    label: t(STATUS_LABEL_KEYS[value]),
    value: toUpper(STATUS_LABEL_KEYS[value])
}));

export const systemTypeFilterOptions = (t) => Object.keys(SYSTEM_TYPES).filter(key => SYSTEM_TYPES[key] !== SYSTEM_TYPES.OVERVIEW).map(key => ({
    label: t(SYSTEM_TYPES[key]),
    value: toUpper(SYSTEM_TYPES[key])
}));

export const fipsFilterOptions = (t) => Object.keys(FIPS_LABEL_KEYS).map(value => ({
    label: t(FIPS_LABEL_KEYS[value]),
    value: toUpper(FIPS_LABEL_KEYS[value])
}));
